/** Разрешает только http(s) URL — как safeUrl() в PHP index.php */
export function safeUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') return '#'
  try {
    const u = new URL(url, window.location.origin)
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return '#'
    return u.toString()
  } catch {
    return '#'
  }
}
